import { Component, input } from '@angular/core';

@Component({
  selector: 'rid-syllabic-text-input',
  imports: [],
  templateUrl: './rid-syllabic-text-input.html',
})
export class RidSyllabicTextInput {
  variant = input.required<'STOM' | 'NORMAAL'>();
}
